import React from 'react';
import { Flex, FlexProps } from 'rebass';

export interface LegendaryLabelProps {
  variant?: string;
  children: string;
}

export const LegendaryLabel: React.FC<
  LegendaryLabelProps | Omit<FlexProps, 'css'>
> = ({ children, variant, ...props }) => (
  <Flex tx="forms" as="legend" {...props} variant={variant ? variant : 'label'}>
    {children}
  </Flex>
);
